import './App.css';
import './Components/_shared/styles/main.scss'
import Header from './Components/Content/Header';
import Main from './Components/Content/Main';
import Footer from './Components/Content/Footer';

function App() {
  return (
    <div className='app'>
      <Header />
      <Main />
      <Footer />
    </div>
  );
}

export default App;
